import {useContext, useEffect, useRef} from 'react';
import {AdRefreshContext} from './AdRefreshContext';

export function useAdRefresh(refreshCallback: () => void, deps?: any[]) {
	const context = useContext(AdRefreshContext);
	if (!context) {
		return;
	}

	const lastRefreshKeyChangeTime = useRef(Date.now());

	useEffect(() => {
		return context.onRefresh.on(() => {
			// Workaround for ignoring immediate banner refresh after mount caused by
			// update the refresh key not being asynchronous with mount (part determined by router parameters, part by the redux store state)
			const nowTime = Date.now();
			if (nowTime - lastRefreshKeyChangeTime.current < 1000) {
				return;
			}
			lastRefreshKeyChangeTime.current = nowTime;
			refreshCallback();
		});
	}, deps || [refreshCallback]);
}

useAdRefresh.displayName = 'useAdRefresh';
